import { parseISO } from "date-fns";

// Shared "working date" synced between Daily Lottery and Store Paperwork tabs.
const SHARED_DATE_KEY = "shared_work_date";

export const readSharedDate = () => {
  try {
    const s = sessionStorage.getItem(SHARED_DATE_KEY);
    if (s && /^\d{4}-\d{2}-\d{2}$/.test(s)) {
      const d = parseISO(s);
      if (!isNaN(d.getTime())) return d;
    }
  } catch {
    // sessionStorage unavailable (private mode) — ignore
  }
  return null;
};

export const writeSharedDate = (dateStr) => {
  try {
    sessionStorage.setItem(SHARED_DATE_KEY, dateStr);
  } catch {
    // ignore
  }
};

export const clearSharedDate = () => {
  try {
    sessionStorage.removeItem(SHARED_DATE_KEY);
  } catch {
    // ignore
  }
};
